/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Equipment from './equipment';
import EquipmentDetail from './equipment-detail';
import EquipmentUpdate from './equipment-update';
import EquipmentDeleteDialog from './equipment-delete-dialog';

const EquipmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Equipment />} />
    <Route path="new" element={<EquipmentUpdate />} />
    <Route path=":id">
      <Route index element={<EquipmentDetail />} />
      <Route path="edit" element={<EquipmentUpdate />} />
      <Route path="delete" element={<EquipmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default EquipmentRoutes;
